import { PublicServiceMissionsSliceType } from '../../../../types/slice';
import { toTextFromProp } from '../../fields/text';

export const timelineSlice = ({ primary, items }) => ({
  type: PublicServiceMissionsSliceType.TIMELINE,
  items,
  title: toTextFromProp('title', primary),
});
